import type { ReactNode } from 'react'
import { TitleDivider } from '@cocoonspace/ui/components/cocoon/title-divider'
import { Skeleton } from '@cocoonspace/ui/components/skeleton'
import { cn } from '@cocoonspace/ui/lib/utils'

export const SectionHeader = ({
	title,
	subtitle,
	className,
	subtitleClassName,
}: {
	title: ReactNode
	subtitle?: ReactNode
	className?: string
	subtitleClassName?: string
}) => (
	<div className={cn('flex flex-col gap-2', className)}>
		<div className={cn('flex flex-col gap-1', className)}>
			<h1 className='text-4xl leading-none font-black'>{title}</h1>
			{subtitle && <div className={cn(subtitleClassName)}>{subtitle}</div>}
		</div>

		<TitleDivider />
	</div>
)

SectionHeader.skeleton = ({ subtitle }: { subtitle?: boolean }) => (
	<div className='flex flex-col gap-2'>
		<div className='flex flex-col gap-1'>
			<Skeleton className='h-[39px] w-[150px]' />
			{subtitle && <Skeleton className='h-[21px] w-[300px]' />}
		</div>

		<TitleDivider />
	</div>
)
